if (internationalRestrictions.items.length > 0) {
  checkRestrictions(internationalRestrictions);

  let mainCartItems = document.getElementById('main-cart-items');
  if (mainCartItems) {
    mainCartItems.addEventListener("updateCartComplete", function () {
      checkRestrictions(internationalRestrictions);
    });
  }
};


function checkRestrictions(itemsArray){
  const country = sessionStorage.getItem('country');
  let messageSelector;
  let submitSelector;
  let submitAllowed = true;

  itemsArray.items.forEach(item => {
    let itemContainer = document.querySelector('['+item.attribute+'="'+item.id+'"]');

    if (country && item.countries.indexOf(country) === -1 && itemContainer) {
      submitAllowed = false;

      if (item.message) {
        let span = document.createElement('span');
        span.classList.add('restricted','text-primary-error');
        span.textContent = item.message;

        let lineItemMessage = document.createElement('div');
        lineItemMessage.classList.add('cart-item__message');
        lineItemMessage.append(span);

        let itemDetails = itemContainer.querySelector('.cart-item__details');
        itemDetails.append(lineItemMessage);
      }

      let removeButton = itemContainer.querySelector('cart-remove-button a');
      if (removeButton) {
        removeButton.classList.add('highlight');
      }
    }

    submitSelector = item.submitButton;
    messageSelector = item.messageContainer;
  });
  
  let submitButton = document.querySelector(submitSelector);
  let messageContainer = document.querySelector(messageSelector);

  if (submitAllowed) {
    updateButton(submitButton, true, messageContainer);
  } else {
    updateButton(submitButton, false, messageContainer, itemsArray.message);
  }
}

function updateButton(object, status, messageContainer, message = false){
  let dynamicCartButtons = document.querySelector('.cart__dynamic-checkout-buttons');

  if (status) {
    object.disabled = false;

    if (dynamicCartButtons) {
      dynamicCartButtons.classList.remove('hidden');
    }

  } else {
    object.disabled = true;

    if (dynamicCartButtons) {
      dynamicCartButtons.classList.add('hidden');
    }

    if (messageContainer.querySelector('span')) {
      messageContainer.querySelector('span').textContent = message;
    } else {
      messageContainer.textContent = message;
    }
    messageContainer.removeAttribute('hidden');
  }
}